var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinancialTechnology = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Crypto-Currency-Bitcoin--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Crypto Currency Bitcoin Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.25a0.25 0.25 0 0 0 -0.25 0.25v1a0.25 0.25 0 0 0 0.25 0.25H13a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.25h-1.5a0.25 0.25 0 0 0 -0.25 0.25v1a0.25 0.25 0 0 0 0.25 0.25H13a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0A2.5 2.5 0 0 0 18 2.5a2.49 2.49 0 0 0 0.13 0.77 0.26 0.26 0 0 1 -0.07 0.25L17 4.6a0.25 0.25 0 0 1 -0.33 0 7.48 7.48 0 0 0 -9.3 0 0.25 0.25 0 0 1 -0.37 0L5.94 3.52a0.26 0.26 0 0 1 -0.07 -0.25A2.49 2.49 0 0 0 6 2.5a2.53 2.53 0 1 0 -1.73 2.37 0.24 0.24 0 0 1 0.25 0.07L5.69 6.1a0.26 0.26 0 0 1 0 0.31 7.48 7.48 0 0 0 5.07 11.48 0.26 0.26 0 0 1 0.21 0.25v0.91a0.25 0.25 0 0 1 -0.14 0.23 2.5 2.5 0 1 0 2.28 0 0.25 0.25 0 0 1 -0.14 -0.23v-0.91a0.26 0.26 0 0 1 0.21 -0.25 7.48 7.48 0 0 0 5.1 -11.48 0.26 0.26 0 0 1 0 -0.31l1.17 -1.16a0.26 0.26 0 0 1 0.25 -0.07A2.5 2.5 0 1 0 20.5 0ZM9.75 7.5a0.76 0.76 0 0 1 0.75 -0.75 0.25 0.25 0 0 0 0.25 -0.25 0.75 0.75 0 0 1 1.5 0 0.25 0.25 0 0 0 0.25 0.25h0.5A2.25 2.25 0 0 1 15.25 9a2.2 2.2 0 0 1 -0.46 1.35 0.24 0.24 0 0 0 0 0.3 2.2 2.2 0 0 1 0.46 1.35A2.25 2.25 0 0 1 13 14.25h-0.5a0.25 0.25 0 0 0 -0.25 0.25 0.75 0.75 0 0 1 -1.5 0 0.25 0.25 0 0 0 -0.25 -0.25 0.76 0.76 0 0 1 -0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinancialTechnology);
export default ForwardRef;